import React, { useCallback } from "react";
import '../../../Styles/Layout/InputArea.css'
import { useAuth } from "../../../contexts/AuthContext";
import { SubmitButton } from "../Buttons/SubmitButton";
import AttachButton from "../Input-Area/AttachButton";
import { useChatContext } from "../../../contexts/AppDataContext";
import { useAttachmentContext } from "../../../contexts/AttachmentContext";
import { AttachedFilesSection } from "../Input-Area/attachedFilesSection";
import { PromptFixButton } from "../Buttons/PromptFixButton";
import MiniUpgradeComponent from "../MiniUpgradeComponent";
import { QuotedContentDisplay } from "../Input-Area/QuotedContentDisplay";
import { CurrentResourceIndicator } from "../Input-Area/CurrentResourceIndicator";
import { useMode } from "../../../contexts/ModeContext";
import { useModelContext } from "../../../contexts/ModelContext";
import WebSearchToggle from "../../WebSearch/WebSearchToggle";
import { ResponseSettingsPicker } from "../ResponseSettingsPicker";

interface InputAreaProps {
  handleSubmit: (event: React.FormEvent) => void;
  textareaProps: any;
  internalRef: (el: HTMLTextAreaElement | null) => void;
  isChat: boolean;
  HandleStopStreaming: () => void;
  isSubmitting: boolean;
  input: string;
  setInput: (input: string) => void;
  forwardedRef?: React.Ref<HTMLTextAreaElement>;
}

export const InputArea: React.FC<InputAreaProps> = ({
  handleSubmit,
  textareaProps,
  internalRef,
  isChat,
  HandleStopStreaming,
  isSubmitting,
  input,
  setInput,
  forwardedRef
}) => {
  const auth = useAuth();
  const { mode, setMode } = useMode();
  const { currentModel, setCurrentModel } = useModelContext();
  const { isFileProcessing } = useAttachmentContext();
  const { isStreaming } = useChatContext();
  const noChatsLeft = auth.user && auth.chatUsageData?.remaining === 0;

  const combinedRef = useCallback((el: HTMLTextAreaElement | null) => {
    internalRef(el);
    if (forwardedRef) {
      if (typeof forwardedRef === 'function') {
        forwardedRef(el);
      } else {
        (forwardedRef as React.MutableRefObject<HTMLTextAreaElement | null>).current = el;
      }
    }
  }, [forwardedRef, internalRef]);

  return (
    <>
      {isChat && <CurrentResourceIndicator />}
      <form
        className={`input-wrapper ${isChat ? 'chat' : 'empty'} ${auth.user ? '' : 'nouser'}`}
        onSubmit={handleSubmit}
        aria-label="Message input form"
      >
        <div className="input-capsule">
          {isChat && <QuotedContentDisplay />}
          <AttachedFilesSection />
          <div className="input-capsule-row">
            <textarea {...textareaProps} ref={combinedRef} />
            <SubmitButton
              isSubmitting={isSubmitting}
              input={input}
              isFileProcessing={isFileProcessing}
              onStopStreaming={HandleStopStreaming}
              isStreaming={isStreaming}
            />
          </div>
        </div>

        <div className="input-toolbar">
          <div className="input-toolbar-left">
            { !noChatsLeft ? (
              <>
                <AttachButton isChat={isChat} />
                <WebSearchToggle />
                <PromptFixButton input={input} setInput={setInput} />
              </>
            ) : (
              <MiniUpgradeComponent />
            )}
          </div>
          <div className="input-toolbar-right">
            <ResponseSettingsPicker
              currentMode={mode}
              setMode={setMode}
              currentModel={currentModel}
              setCurrentModel={setCurrentModel}
              isChat={isChat}
            />
          </div>
        </div>
      </form>
    </>
  );
};
